import priceSimulator3dManifest from './price-simulator-3d/manifest';
import boxGeneratorManifest from './box-generator/manifest';

export const EXTENSION_CATALOG = [priceSimulator3dManifest, boxGeneratorManifest];

export const findExtension = (id) => EXTENSION_CATALOG.find((ext) => ext.id === id);
